import React from 'react';

const AWS_DynamoDB_vs_RDS = () => {
  return (
    <div>
      <h1>AWS_DynamoDB_vs_RDS</h1>
      <p>This is the AWS_DynamoDB_vs_RDS component.</p>
    </div>
  );
};

export default AWS_DynamoDB_vs_RDS;
